import React from 'react'
import { PropsWithChildren } from 'react'
import { wrap } from '../../../utils/globalUtils'
import useAppAuthProvider from './hooks/useAppAuthProvider'
import { useAppAuthProviderProps } from './types'
import AppAuthProviderView from './views/AppAuthProviderView'

const AppAuthProvider: React.FC<PropsWithChildren<useAppAuthProviderProps>> = wrap(AppAuthProviderView, useAppAuthProvider)
export default AppAuthProvider
